<div class="admin-bar">Admin</div>
<app-menu></app-menu>
<app-login-validation (loggedIn)="onLoginValidated($event)"></app-login-validation>

<div class="page">
  <div class="container">
    <h1>Publicação Admin</h1>
    <p class="subtitle">Crie e publique um livro completo em nome de um autor.</p>

    <ng-container *ngIf="isLoading; else mainTpl">
      <div class="spinner">
        <mat-progress-spinner mode="indeterminate" diameter="56"></mat-progress-spinner>
      </div>
    </ng-container>

    <ng-template #mainTpl>
      <form [formGroup]="model" (ngSubmit)="confirmPublish()">

        <!-- ========= IDENTIFICAÇÃO ========= -->
        <h2 class="section-title">Identificação</h2>
        <p class="subtitle">Dados do autor e do livro</p>

        <div class="fields-row">
          <div class="field">
            <label class="label">Autor (Usuário do sistema)</label>

            <!-- Usuário selecionado -->
            <div *ngIf="selectedUser; else userPickerTpl" class="selected-user">
              <div class="user-badge">
                <div class="name">{{ selectedUser.userName }}</div>
                <div class="email">{{ selectedUser.userEmail }}</div>
              </div>

              <button mat-button type="button" (click)="clearUser()" [disabled]="lockUserSelect">
                <mat-icon>close</mat-icon> Trocar
              </button>
            </div>

            <!-- Seletor -->
            <ng-template #userPickerTpl>
              <div class="user-picker-row">
                <mat-form-field appearance="outline" class="w-100">
                  <mat-label>Buscar usuário ativo</mat-label>
                  <input matInput type="text" [matAutocomplete]="autoUser" [value]="userSearch"
                    (input)="onUserSearch($any($event.target).value || '')" [disabled]="lockUserSelect" />
                  <mat-autocomplete #autoUser="matAutocomplete" (optionSelected)="onUserSelected($event.option.value)">
                    <mat-option *ngFor="let u of filteredUsers; trackBy: trackByUser" [value]="u">
                      {{ u.userName }} — {{ u.userEmail }}
                    </mat-option>
                    <mat-option *ngIf="filteredUsers.length === 0" disabled>Nenhum usuário encontrado</mat-option>
                  </mat-autocomplete>
                  <mat-hint>Selecionar usuário que corresponde ao autor do livro.</mat-hint>
                </mat-form-field>

                <button type="button" class="icon-btn btn-green" (click)="openCreateUserModal()"
                  matTooltip="Criar novo usuário">
                  <mat-icon>add</mat-icon>
                </button>
              </div>
            </ng-template>

            <!-- Campo hidden ou somente leitura, se quiser manter visível -->
            <input type="hidden" formControlName="idUserAuthor" />
          </div>
        </div>

        <div class="fields-row">
          <mat-form-field appearance="outline" class="field">
            <mat-label>Nome do autor (capa)</mat-label>
            <input matInput formControlName="coverAuthorName" />
          </mat-form-field>

          <mat-form-field appearance="outline" class="field">
            <mat-label>Título</mat-label>
            <input matInput formControlName="bookTitle" />
          </mat-form-field>

          <mat-form-field appearance="outline" class="field">
            <mat-label>Subtítulo</mat-label>
            <input matInput formControlName="bookSubtitle" />
          </mat-form-field>
        </div>

        <div class="fields-row">
          <mat-form-field appearance="outline" class="field">
            <mat-label>Edição / Versão</mat-label>
            <input matInput formControlName="versionName" />
          </mat-form-field>

          <mat-form-field appearance="outline" class="field">
            <mat-label>Nome da coleção</mat-label>
            <input matInput formControlName="collectionName" />
          </mat-form-field>

          <mat-form-field appearance="outline" class="field">
            <mat-label>Volume / número da coleção</mat-label>
            <input matInput formControlName="volumeName" />
          </mat-form-field>
        </div>

        <div class="fields-row">
          <mat-form-field appearance="outline" class="field">
            <mat-label>Total de páginas</mat-label>
            <input matInput type="number" formControlName="totalPages" />
          </mat-form-field>

          <!-- <mat-form-field appearance="outline" class="field">
            <mat-label>ISBN</mat-label>
            <input matInput formControlName="isbn" />
          </mat-form-field>

          <mat-form-field appearance="outline" class="field">
            <mat-label>DOI</mat-label>
            <input matInput formControlName="doi" />
          </mat-form-field> -->

          <mat-form-field appearance="outline" class="field col-12 col-md-6">
            <mat-label>ISBN</mat-label>
            <input matInput formControlName="isbn" maxlength="17" placeholder="978-85-0000-000-0" />
            <mat-hint>Somente números e hífens (10 ou 13 dígitos).</mat-hint>
            <mat-error
              *ngIf="model.controls['isbn'].invalid && (model.controls['isbn'].dirty || model.controls['isbn'].touched)">
              Informe um ISBN válido (10 ou 13 dígitos, pode conter hífens).
            </mat-error>
          </mat-form-field>

          <mat-form-field appearance="outline" class="field col-12 col-md-6">
            <mat-label>DOI</mat-label>
            <input matInput formControlName="doi" maxlength="500" placeholder="10.1007/978-1-4842-3630-7" />
            <mat-hint>Identificador de Objeto Digital (DOI)</mat-hint>
          </mat-form-field>


        </div>

        <mat-form-field appearance="outline" class="synopsis-field">
          <mat-label>Sinópse (min. 500 e máx. 800 caracteres)</mat-label>
          <textarea matInput formControlName="synopsis" rows="4"></textarea>
          <mat-hint>{{ model.get('synopsis')?.value?.length || 0 }}/800</mat-hint>
        </mat-form-field>

        <mat-form-field appearance="outline" class="synopsis-field">
          <mat-label>Epígrafe (máx. 250 caracteres)</mat-label>
          <textarea matInput formControlName="preface" rows="4"></textarea>
          <mat-hint>{{ model.get('preface')?.value?.length || 0 }}/250</mat-hint>
        </mat-form-field>

        <!-- ========= CATEGORIAS ========= -->
        <h2 class="section-title">Categorias</h2>
        <p class="subtitle">Categorias primária e secundária</p>

        <div class="fields-row">
          <mat-form-field appearance="outline" class="field">
            <mat-label>Categoria primária</mat-label>
            <mat-select formControlName="idPrimaryCategory">
              <mat-option [value]="null" disabled>Selecione</mat-option>
              <ng-container *ngFor="let opt of primaryOptions; trackBy: trackByOption">
                <mat-option *ngIf="opt.isHeader" disabled>
                  <b style="color:#28a745;background:#f6f6f6;">{{ opt.label }}</b>
                </mat-option>
                <mat-option *ngIf="!opt.isHeader" [value]="opt.idCategory">
                  {{ opt.label }}
                </mat-option>
              </ng-container>
            </mat-select>
          </mat-form-field>

          <mat-form-field appearance="outline" class="field">
            <mat-label>Categoria secundária</mat-label>
            <mat-select formControlName="idSecondaryCategory">
              <mat-option [value]="null" disabled>Selecione</mat-option>
              <ng-container *ngFor="let opt of secondaryOptions; trackBy: trackByOption">
                <mat-option *ngIf="opt.isHeader" disabled>{{ opt.label }}</mat-option>
                <mat-option *ngIf="!opt.isHeader" [value]="opt.idCategory">
                  {{ opt.label }}
                </mat-option>
              </ng-container>
            </mat-select>
          </mat-form-field>
        </div>

        <!-- ========= AUTORES ========= -->
        <h2 class="section-title">Autores</h2>
        <p class="subtitle">Inclua todos os autores (o primeiro será o principal).</p>

        <div formArrayName="listAuthors">
          <div class="authors-row" *ngFor="let authorCtrl of authors.controls; let i = index">
            <mat-form-field appearance="outline" class="author-field">
              <mat-label>Autor {{ i === 0 ? 'principal' : '' }}</mat-label>
              <input matInput [formControlName]="i" />
            </mat-form-field>

            <button type="button" class="icon-btn btn-green" (click)="addAuthor()">
              <mat-icon>add</mat-icon>
            </button>

            <button type="button" class="icon-btn btn-red" *ngIf="authors.length > 1" (click)="removeAuthor(i)">
              <mat-icon>delete</mat-icon>
            </button>
          </div>
        </div>

        <!-- ========= BIO + FOTO DO AUTOR ========= -->
        <h2 class="section-title">Bio do autor (orelha da contracapa)</h2>
        <p class="subtitle">Biografia e foto do autor</p>

        <div class="author-bio-row">
          <div class="author-photo-area">
            <div class="photo-drop-area" (drop)="onAuthorPhotoDrop($event)" (dragover)="onDragOver($event)">
              <ng-container *ngIf="!authorPhotoPreview; else authorPhotoTpl">
                <span>Arraste a foto do autor aqui<br />ou</span>
                <button type="button" mat-raised-button (click)="authorPhotoInput.click()">Selecionar foto</button>
                <input #authorPhotoInput type="file" accept="image/*" hidden (change)="onAuthorPhotoSelected($event)" />
              </ng-container>

              <ng-template #authorPhotoTpl>
                <img class="author-photo-preview" [src]="authorPhotoPreview" alt="Foto do Autor" [ngClass]="{
                    'photo-square': model.get('idPhotoShape')?.value === 1,
                    'photo-round': model.get('idPhotoShape')?.value === 2
                  }" />
                <button mat-stroked-button color="warn" type="button" (click)="clearAuthorPhoto()">
                  Remover
                </button>
              </ng-template>
            </div>

            <div class="photo-shape-options">
              <div class="shape-choice" [class.selected]="model.get('idPhotoShape')?.value === 1"
                (click)="model.patchValue({ idPhotoShape: 1 }); cdr.markForCheck()">
                <span class="icon-label">
                  <svg width="28" height="28">
                    <rect x="4" y="4" width="20" height="20" rx="5" fill="none" stroke="#28a745" stroke-width="3">
                    </rect>
                  </svg>
                  <span>Quadrada</span>
                </span>
              </div>

              <div class="shape-choice" [class.selected]="model.get('idPhotoShape')?.value === 2"
                (click)="model.patchValue({ idPhotoShape: 2 }); cdr.markForCheck()">
                <span class="icon-label">
                  <svg width="28" height="28">
                    <circle cx="14" cy="14" r="10" fill="none" stroke="#28a745" stroke-width="3"></circle>
                  </svg>
                  <span>Redonda</span>
                </span>
              </div>
            </div>
          </div>

          <div class="author-bio-area">
            <mat-form-field appearance="outline" class="bio-field">
              <mat-label>Biografia do autor (máx. 4000 caracteres)</mat-label>
              <textarea matInput formControlName="authorBio" rows="8" maxlength="4000"></textarea>
              <mat-hint align="end">{{ model.get('authorBio')?.value?.length || 0 }}/4000</mat-hint>
            </mat-form-field>
          </div>
        </div>

        <!-- ========= UPLOADS DE CAPA / CONTRACAPA / PDF ========= -->
        <h2 class="section-title">Arquivos do livro</h2>
        <p class="subtitle">
          Estes uploads entram no fluxo admin (base64). Se você insistir em enfiar arquivos gigantes aqui, vai sofrer
          com payload e timeout.
          Use arquivos enxutos, principalmente para PDF.
        </p>

        <div class="upload-grid">
          <!-- CAPA -->
          <div class="upload-card">
            <div class="upload-title">Capa (Front)</div>
            <div class="upload-box" (click)="frontCoverInput.click()">
              <ng-container *ngIf="frontCoverPreview; else frontCoverEmpty">
                <img class="upload-preview" [src]="frontCoverPreview" alt="Capa frontal" />
              </ng-container>
              <ng-template #frontCoverEmpty>
                <div class="empty-state">
                  <strong>Selecionar capa</strong>
                  <p>.jpg, .png, .webp</p>
                </div>
              </ng-template>
            </div>
            <input #frontCoverInput type="file" accept="image/*" hidden (change)="onFrontCoverSelected($event)" />
            <button mat-button type="button" (click)="clearFrontCover()" *ngIf="frontCoverPreview">Remover</button>
          </div>

          <!-- CONTRACAPA -->
          <div class="upload-card">
            <div class="upload-title">Contracapa (Back)</div>
            <div class="upload-box" (click)="backCoverInput.click()">
              <ng-container *ngIf="backCoverPreview; else backCoverEmpty">
                <img class="upload-preview" [src]="backCoverPreview" alt="Contracapa" />
              </ng-container>
              <ng-template #backCoverEmpty>
                <div class="empty-state">
                  <strong>Selecionar contracapa</strong>
                  <p>.jpg, .png, .webp</p>
                </div>
              </ng-template>
            </div>
            <input #backCoverInput type="file" accept="image/*" hidden (change)="onBackCoverSelected($event)" />
            <button mat-button type="button" (click)="clearBackCover()" *ngIf="backCoverPreview">Remover</button>
          </div>

          <!-- CAPA PARA PRINT (PDF) -->
          <div class="upload-card">
            <div class="upload-title">Capa para impressão (PDF)</div>
            <div class="upload-box file" (click)="coverPrintInput.click()">
              <div class="empty-state" *ngIf="!coverForPrintLabel">
                <strong>Selecionar PDF</strong>
                <p>.pdf</p>
              </div>
              <div class="file-label" *ngIf="coverForPrintLabel">
                {{ coverForPrintLabel }}
              </div>
            </div>
            <input #coverPrintInput type="file" accept="application/pdf" hidden
              (change)="onCoverForPrintSelected($event)" />
            <button mat-button type="button" (click)="clearCoverForPrint()" *ngIf="coverForPrintLabel">Remover</button>
          </div>

          <!-- LIVRO PARA PRINT (PDF) -->
          <div class="upload-card">
            <div class="upload-title">Livro para impressão (PDF)</div>
            <div class="upload-box file" (click)="bookPrintInput.click()">
              <div class="empty-state" *ngIf="!bookForPrintLabel">
                <strong>Selecionar PDF</strong>
                <p>.pdf</p>
              </div>
              <div class="file-label" *ngIf="bookForPrintLabel">
                {{ bookForPrintLabel }}
              </div>
            </div>
            <input #bookPrintInput type="file" accept="application/pdf" hidden
              (change)="onBookForPrintSelected($event)" />
            <button mat-button type="button" (click)="clearBookForPrint()" *ngIf="bookForPrintLabel">Remover</button>
          </div>

          <!-- EBOOK (PDF) -->
          <div class="upload-card">
            <div class="upload-title">E-book (PDF)</div>
            <div class="upload-box file" (click)="ebookInput.click()">
              <div class="empty-state" *ngIf="!bookForEbookLabel">
                <strong>Selecionar PDF</strong>
                <p>.pdf</p>
              </div>
              <div class="file-label" *ngIf="bookForEbookLabel">
                {{ bookForEbookLabel }}
              </div>
            </div>
            <input #ebookInput type="file" accept="application/pdf" hidden (change)="onBookForEbookSelected($event)" />
            <button mat-button type="button" (click)="clearBookForEbook()" *ngIf="bookForEbookLabel">Remover</button>
          </div>
        </div>

        <!-- ========= TIPO DE IMPRESSÃO ========= -->
        <h2 class="section-title">Tipo de impressão</h2>
        <p class="subtitle">Selecione o tipo de impressão para cálculo de dimensões/peso.</p>

        <div class="print-table-wrap" *ngIf="listBookPrint?.length; else noPrintTpl">
          <table class="print-table">
            <thead>
              <tr>
                <th></th>
                <th>Tamanho</th>
                <th>Descrição</th>
                <th>Custo estimado</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let p of listBookPrint; trackBy: trackByPrint"
                [ngClass]="{ 'selected': model.get('idBookPrint')?.value === p.idBookPrint }"
                (click)="selectBookPrint(p.idBookPrint)">
                <td>
                  <input type="radio" [value]="p.idBookPrint" formControlName="idBookPrint" name="idBookPrint" />
                </td>
                <td>{{ p.bookPrintSize }}</td>
                <td>{{ p.bookPrintDescription }}</td>
                <td>R$ {{ (p.rawUnitCost || 0).toFixed(2) }}</td>
              </tr>
            </tbody>
          </table>
        </div>

        <ng-template #noPrintTpl>
          <div class="empty">
            Primeiro informe o total de páginas acima para caregar os tipos de impressão disponíveis.
          </div>
        </ng-template>

        <!-- ========= KITS ========= -->
        <div class="section-kits">
          <h2 class="section-title">Kits de venda</h2>
          <p class="subtitle">Monte diferentes combinações de itens para vender seu livro</p>

          <div class="kit-item" *ngFor="let kit of request.listKitStruct; let i = index">
            <div class="kit-row row g-3">

              <mat-form-field appearance="outline" class="field col-12 col-sm-6 col-md-3">
                <mat-label>Nome do kit</mat-label>
                <input matInput [(ngModel)]="kit.kitName" [ngModelOptions]="{ standalone: true }" name="kitName{{i}}" />
              </mat-form-field>

              <mat-form-field appearance="outline" class="field col-12 col-sm-6 col-md-3">
                <mat-label>Itens</mat-label>
                <mat-select multiple [(ngModel)]="kit.selectedItems" [ngModelOptions]="{ standalone: true }"
                  name="kitItems{{i}}" (selectionChange)="applyPriceGuards(kit)">
                  <mat-option value="book" [disabled]="!hasPrintPdfs">Livro físico</mat-option>
                  <mat-option value="ebook" [disabled]="!hasEbookPdf">E-book</mat-option>
                  <mat-option value="video" [disabled]="!hasAnyCourse">Curso / Vídeos</mat-option>
                </mat-select>

                <!-- <mat-hint *ngIf="!hasAnyCourse" class="warn-missing-course">
                  Cursos/vídeos ainda não cadastrados. Opção “Curso / Vídeos” indisponível.
                </mat-hint>
                <mat-hint *ngIf="!hasEbookPdf" class="warn-missing-course">
                  PDF de e-book não anexado. Opção “E-book” indisponível.
                </mat-hint>
                <mat-hint *ngIf="!hasPrintPdfs" class="warn-missing-course">
                  PDFs de impressão não anexados. Opção “Livro físico” indisponível.
                </mat-hint> -->
              </mat-form-field>

              <mat-form-field appearance="outline" class="field col-12 col-sm-6 col-md-3">
                <mat-label>Valor total (R$)</mat-label>
                <input matInput [value]="formatCurrency(kit.totalPrice)" (keyup)="onCurrencyInput($event, kit)"
                  (blur)="onCurrencyBlur(kit)" name="kitTotal{{ i }}" />

                <mat-hint>
                  mín: {{ formatCurrency(getMinPriceForKit(kit)) }}
                </mat-hint>
              </mat-form-field>

              <div class="kit-actions col-12 col-sm-6 col-md-3">
                <button class="btn-add" type="button" (click)="addKit()">
                  <mat-icon>add</mat-icon>
                </button>
                <button class="btn-remove" type="button" *ngIf="request.listKitStruct.length > 1" (click)="removeKit(i)"
                  matTooltip="Remover kit">
                  <mat-icon>delete</mat-icon>
                </button>
              </div>

            </div>
          </div>
        </div>

        <!-- ========= CAPÍTULOS / VÍDEOS ========= -->
        <!-- <h2 class="section-title">Vídeos e cursos (metadados)</h2>
        <p class="subtitle">
          Nesta publicação admin você cria a estrutura (capítulos e vídeos). Upload de arquivos deve ser feito via endpoint dedicado.
        </p>

        <div class="list-header">
          <button mat-stroked-button color="primary" type="button" (click)="addChapter()">+ Capítulo</button>
        </div>

        <mat-accordion>
          <mat-expansion-panel *ngFor="let chapter of listVideoChapter; let i = index">
            <mat-expansion-panel-header>
              <mat-panel-title>{{ chapter.name || 'Capítulo ' + (i + 1) }}</mat-panel-title>
              <mat-panel-description>{{ chapter.description || 'Sem descrição' }}</mat-panel-description>
            </mat-expansion-panel-header>

            <div class="chapter-edit-grid">
              <div class="chapter-form">
                <mat-form-field appearance="outline" class="field">
                  <mat-label>Nome do capítulo</mat-label>
                  <input matInput [(ngModel)]="chapter.name" name="chapterName{{i}}" />
                </mat-form-field>

                <mat-form-field appearance="outline" class="field">
                  <mat-label>Descrição</mat-label>
                  <textarea matInput rows="4" [(ngModel)]="chapter.description" name="chapterDesc{{i}}"></textarea>
                </mat-form-field>
              </div>

              <div class="chapter-hint">
                <div class="hint-box">
                  <div class="hint-title">Arquivos do capítulo</div>
                  <div class="hint-body">
                    Capa e arquivos serão enviados depois via upload dedicado.
                    Aqui você cria só os metadados.
                  </div>
                </div>
              </div>
            </div>

            <hr />

            <div class="list-items">
              <div class="list-card" *ngFor="let video of chapter.listVideoStruct; let j = index">
                <div class="row g-3 align-items-stretch video-row">
                  <div class="col-12 col-sm-12 col-md-12 col-lg-5">
                    <mat-form-field appearance="outline" class="w-100 mb-2">
                      <mat-label>Título</mat-label>
                      <input matInput [(ngModel)]="video.title" name="videoTitle{{i}}-{{j}}" />
                    </mat-form-field>

                    <mat-form-field appearance="outline" class="w-100">
                      <mat-label>Descrição</mat-label>
                      <textarea matInput rows="3" [(ngModel)]="video.description" name="videoDesc{{i}}-{{j}}"></textarea>
                    </mat-form-field>
                  </div>

                  <div class="col-12 col-sm-12 col-md-12 col-lg-5">
                    <div class="hint-box">
                      <div class="hint-title">Arquivos do vídeo</div>
                      <div class="hint-body">
                        Upload de vídeo/PDF e miniatura via endpoint dedicado após a publicação.
                      </div>
                    </div>
                  </div>

                  <div class="col-12 col-sm-12 col-md-12 col-lg-2 d-flex align-items-start gap-2 kit-actions">
                    <button class="btn-add" type="button" (click)="addVideo(i)" matTooltip="Adicionar vídeo">
                      <mat-icon>add</mat-icon>
                    </button>
                    <button class="btn-remove" type="button" *ngIf="chapter.listVideoStruct.length > 1" (click)="removeVideo(i, j)" matTooltip="Remover vídeo">
                      <mat-icon>delete</mat-icon>
                    </button>
                  </div>
                </div>
              </div>
            </div>

            <div class="actions-inline">
              <button mat-button class="btn-remove" style="color:#fff;" type="button" (click)="removeChapter(i)">
                Remover capítulo
              </button>
            </div>
          </mat-expansion-panel>
        </mat-accordion> -->

        <!-- ========= MARKETPLACE ========= -->
        <div class="marketplace-flag">
          <mat-slide-toggle color="primary" [(ngModel)]="isMarketplaceEnabled" [ngModelOptions]="{ standalone: true }"
            name="isMarketplaceEnabled">
            Liberado para marketplace (Amazon)
          </mat-slide-toggle>
          <p class="subtitle" style="margin:6px 0 0;">
            O livro físico será publicado na Amazon automaticamente assim que for sincronizado com o Base ERP e
            tiver ISBN e um kit com livro físico. Depois de sincronizado, a edição do livro fica bloqueada.
            O acompanhamento é feito no Editor de livros.
          </p>
        </div>

        <!-- ========= AÇÕES ========= -->
        <div class="details-actions">
          <button class="continue-btn danger" type="button" (click)="resetAll()">Limpar tudo</button>

          <button class="continue-btn" type="submit" [disabled]="model.invalid || isPublishing">
            <ng-container *ngIf="isPublishing; else publishText">
              <mat-progress-spinner mode="indeterminate" diameter="18"></mat-progress-spinner>
            </ng-container>
            <ng-template #publishText>Publicar agora</ng-template>
          </button>
        </div>
      </form>
    </ng-template>
  </div>
</div>

<app-footer></app-footer>